import { SoftwareOnboardingMain } from 'src/components/SoftwareOnboarding';
import {
  MembershipsManagementContainer,
  MembershipsManagementContextProvider,
} from 'src/containers/Escrow/Memberships';
import { useSoftwareEscrow } from 'src/context/software-escrow';

const SoftwareEscrowOnboardingMembers = () => {
  const {
    softwareEscrow: { beneficiary },
  } = useSoftwareEscrow();

  return (
    <MembershipsManagementContextProvider
      beneficiaryId={beneficiary!.id}
      canCreateMember={beneficiary!.policy.createEscrowMemberships}
    >
      <SoftwareOnboardingMain
        subtitle="Members"
        title="Add members to your escrow"
        description="Add team members to this escrow and set their permissions. Their permissions affect how they can contribute to the escrow."
        noteText="Note: By default, the escrow creator and account owner have Manager permissions. You'll need to grant other team members access before they can contribute. If a team member isn't listed, add them to your organization first. You can manage members anytime."
        classes={{ note: 'not-italic' }}
      >
        <div className="max-w-260 w-full mx-auto">
          <MembershipsManagementContainer />
        </div>
      </SoftwareOnboardingMain>
    </MembershipsManagementContextProvider>
  );
};

export default SoftwareEscrowOnboardingMembers;
